import ROUTES from "@consts/routes";
import i18n from "@/lang/i18n";

export default [
  {
    path: 'profile',
    name: ROUTES.TAXI.PROFILE,
    meta: {breadcrumb: i18n.tc('breadcrumbs.Profile'), activeKey: 'taxi.profile'},
    component: () => import("@components/base_auths/Profile"),
  },
];
